import { render, staticRenderFns } from "./PosterClamp.vue?vue&type=template&id=53af04c5&scoped=true"
import script from "./PosterClamp.vue?vue&type=script&lang=js"
export * from "./PosterClamp.vue?vue&type=script&lang=js"
import style0 from "./PosterClamp.vue?vue&type=style&index=0&id=53af04c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af04c5",
  null
  
)

export default component.exports